import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";

import {
  selectDrawerModalIsOpen,
  toggleDrawerModal,
} from "@chef/state-management";

import { BurgerButton } from "@chef/components";
import { FEATURE_FLAGS, language } from "@chef/constants";
import { useFlag } from "@chef/feature-flags";

import { LoyaltyBadge } from "./LoyaltyBadge";

interface DrawerButtonProps {
  isB2B?: boolean;
}

export const DrawerButton = ({ isB2B }: DrawerButtonProps) => {
  const { enabled: isWeekEditorRedesignEnabled } = useFlag(
    FEATURE_FLAGS.WEEK_EDITOR_REDESIGN,
  );

  const dispatch = useDispatch();
  const drawerOpen = useSelector(selectDrawerModalIsOpen);

  const handleToggleDrawer = () => {
    dispatch(toggleDrawerModal());
  };

  return (
    <motion.div initial={false} animate={drawerOpen ? "open" : "closed"}>
      <BurgerButton
        id={drawerOpen ? "close-menu-burger-button" : "open-menu-burger-button"}
        title={drawerOpen ? intl.CLOSE_MENU_LABEL : intl.OPEN_MENU_LABEL}
        onClick={handleToggleDrawer}
        className={clsx(
          "rounded stroke-black px-1",
          !drawerOpen && "hover:bg-grey-2",
        )}
      >
        {!isB2B && !isWeekEditorRedesignEnabled && (
          <LoyaltyBadge className="stroke-none" />
        )}
      </BurgerButton>
    </motion.div>
  );
};

const intl = (
  {
    no: {
      OPEN_MENU_LABEL: "Åpne meny",
      CLOSE_MENU_LABEL: "Lukk meny",
    },
    se: {
      OPEN_MENU_LABEL: "Öppna meny",
      CLOSE_MENU_LABEL: "Stäng meny",
    },
    dk: {
      OPEN_MENU_LABEL: "Åbn menu",
      CLOSE_MENU_LABEL: "Luk menu",
    },
  } as const
)[language];
